import React from 'react';
import { hot } from 'react-hot-loader/root';
import { Provider } from 'react-redux';
import { MicroFEShell } from '@carvana/microfrontend';
import ThemeProvider from '@carvana/theme';
import { AnalyticsProvider } from '@carvana/eventable-clickstream';
import store from './store/configureStore';
import Campaigns from './Campaigns';
import initDataDog from './utilities/datadog';

const headerModule = [
  'HeaderModule',
  [
    {
      component: 'default',
      core: true,
      default: {
        file: 'index.js',
        manifest: `${
          process.env.CARVANA_APP_ASSETS_URL
        }/header/module/assets-manifest.json?v=${Date.now()}`
      }
    }
  ]
];

const footerModule = [
  'FooterModule',
  [
    {
      component: 'default',
      core: true,
      default: {
        file: 'index.js',
        manifest: `${
          process.env.CARVANA_APP_ASSETS_URL
        }/footer/module/assets-manifest.json?v=${Date.now()}`
      }
    }
  ]
];

const shellConfig = {
  globals: {
    React: () => import('react'),
    ReactDOM: () => import('react-dom'),
    'prop-types': () => import('prop-types'),
    PropTypes: () => import('prop-types'),
    styled: () => import('styled-components')
  },
  files: [headerModule, footerModule]
};

// const DEPLOY_ENV_MAPPING = {
//   dev: 'development',
//   test: 'test',
//   uat: 'uat',
//   prod: 'production'
// };

// const env =
//   (process.env.CARVANA_APP_ENVIRONMENT &&
//     DEPLOY_ENV_MAPPING[process.env.CARVANA_APP_ENVIRONMENT.toLowerCase()]) ||
//   'dev';

const App = () => {
  React.useEffect(() => {
    initDataDog();
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider>
        <AnalyticsProvider
          environment={process.env.CARVANA_APP_ENVIRONMENT}
          projectName="Campaigns"
          track="Web"
          // correlationId="some-custom-correlation-id"
          // payloadMetaAttributes={{
          //   supportDropdownId: 'ie89437ghwo40567'
          // }}
          debug
        >
          <MicroFEShell
            config={shellConfig}
            env={process.env.CARVANA_APP_ENVIRONMENT}
            name="carvana-campaigns"
          >
            <Campaigns />
          </MicroFEShell>
        </AnalyticsProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default hot(App);
